import { Popover } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './index.scss'

const InspectItemCom = ({
  report,
  part,
  showIndex,
  col,
  showIcon,
  showColumns
}) => {
  const majorObjTotal = report && report.report_count && report.report_count[part]
  const successNum = (item) => {
    if (item === '随车工具') {
      return showIcon
        ? (majorObjTotal && majorObjTotal[item]?.has_tool_num) || '无'
        : majorObjTotal?.has_tool_num
    }

    return showIcon
      ? majorObjTotal && majorObjTotal[item]?.total_pass_num
      : majorObjTotal?.total_pass_num
  }

  const defectNum = (item) => {
    if (item === '随车工具') { return 0 }
    return showIcon
      ? majorObjTotal && majorObjTotal[item]?.defect_num
      : majorObjTotal?.defect_num
  }

  // 一级检测项
  const getOuterHeadJsx = () => (
    <div
      className="r-c-inspect-head"
      data-exposure={JSON.stringify({
        event: 'ReportDetailPage_ReportsDetail_display',
        content: { expand: { value: part } }
      })}
    >
      <span className="acc_name">{part}</span>
      <span className="hg_sign">合格</span>
      <span className="title_des ellips">{majorObjTotal?.text_report}</span>
    </div>
  )
  // 一级检测项图标
  const getItemIconJsx = (item) => {
    let jsx = <></>
    switch (item) {
      case '重大撞击排查':
        jsx = <i className="iconfont icon-wushigu" />
        break
      case '水泡车排查':
        jsx = <i className="iconfont icon-wushuipao" />
        break
      case '火烧车排查':
        jsx = <i className="iconfont icon-wuhuoshao" />
        break
      case '安全系统':
        jsx = <i className="iconfont icon-anquanxitong" />
        break
      case '转向系统':
        jsx = <i className="iconfont icon-zhuanxiangxitong" />
        break
      case '灯光、空调系统':
        jsx = <i className="iconfont icon-dengguangkongtiaoxitong" />
        break
      case '动力、传动系统':
        jsx = <i className="iconfont icon-donglichuandongxitong" />
        break
      case '内部配置':
        jsx = <i className="iconfont icon-neibupeizhi" />
        break
      case '随车工具':
        jsx = <i className="iconfont icon-suichegongju" />
        break
      case '悬挂系统':
        jsx = <i className="iconfont icon-xuanguaxitong" />
        break
      default:
        break
    }
    return jsx
  }
  // 一级检测项header: 有icon 和 无icon
  const getItemHeadJsx = (item) => {
    // 该检测项无瑕疵和有瑕疵
    const numJsx = (
      <div className="title-info_num">
        {
          item === '随车工具' ? <></> : <i className="iconfont icon-test_icon" />
        }
        <span className="test-num">{successNum(item)}{(item === '随车工具') ? (successNum(item) > 0 ? '件' : '') : '项'}</span>
        {defectNum(item) > 0 && (
          <>
            <i className="iconfont icon-type-part-type-icon defect" />
            <span className="test-num">{defectNum(item)}项</span>
          </>
        )}
      </div>
    )
    return showIcon ? (
      <>
        <div className="title-icon">{getItemIconJsx(item)}</div>
        <div className="title-info">
          <p className="title-info_title">{item}</p>
          {numJsx}
        </div>
      </>
    ) : (
      numJsx
    )
  }
  // 正常检测项
  const getUnDefectJsx = title => (
    <div key={title}>
      <i className="iconfont icon-test_smicon" />
      <div className="pass_item_name test-item-name">{title}</div>
    </div>
  )
  // 瑕疵检测项Popover
  const getDefectPopJsx = (item, key, defectArr) => (
    <Popover
      content={defectArr?.map((e, index) => (
        <div key={index}>
          <div
            style={{
              fontSize: '14px',
              color: '#222',
              marginBottom: '10px'
            }}
          >
            {e.title}
          </div>
          <div
            style={{
              fontSize: '12px',
              color: '#a3a3a3'
            }}
          >
            {e.description}
          </div>
        </div>
      ))}
    >
      {item === '随车工具' ? (
        <span className="line">-</span>
      ) : (
        <i className="iconfont icon-tip-icon2-07d8d303" />
      )}
      <div className="pass_item_name test-item-name">{key}</div>
    </Popover>
  )
  // 二级检测项
  const getItemJsx = (item) => {
    if (report?.report && report?.report[part] && report?.report[part][item]) {
      return (
        <div
          key={item}
          className={`r-c-inspect-item ${col ? `col${col}` : showColumns ? '' : 'col1'}`}
        >
          <div className="r-c-inspect-item__title clearfix">
            {getItemHeadJsx(item)}
          </div>
          {/* 随车工具单独处理 */}
          <div className="r-c-inspect-item__content clearfix">
            {item === '随车工具' ? (
              <>
                {report?.report
                && report?.report[part]
                && report?.report[part][item]
                && report?.report[part][item]['随车附件']
                && report?.report[part][item]['随车附件'].items?.map(obj => (
                  <div
                    className={classnames('r-c-inspect-item__content-item', 'clearfixnew', { fail: obj.status === 'n' })}
                    key={obj.title}
                  >
                    {/* 无瑕疵 */}
                    {obj.status !== 'n'
                      ? getUnDefectJsx(obj.title)
                      : getDefectPopJsx(item, obj.title, [obj])}
                  </div>
                ))}
              </>
            ) : (
              <>
                {report?.report
                && report?.report[part]
                && report?.report[part][item]
                && Object.keys(report.report[part][item]).map(key => (
                  <div
                    className={classnames('r-c-inspect-item__content-item', 'clearfixnew', { anomaly: report.report[part][item][key].status !== 'normal' })}
                    key={key}
                  >
                    {report.report[part][item][key].status === 'normal'
                      ? getUnDefectJsx(key)
                      : getDefectPopJsx(
                        item,
                        key,
                        report.report[part][item][key].items || []
                      )}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )
    }
    return <></>
  }
  return (
    <div className="r-c-inspect-wraper clearfix">
      {getOuterHeadJsx()}
      {showIndex && showIndex.map(getItemJsx)}
      {showColumns
          && showColumns.map((column, index) => (
            <div className="column" key={index}>
              {column.map(getItemJsx)}
            </div>
          ))}
    </div>
  )
}
export default InspectItemCom

InspectItemCom.propTypes = {
  report: PropTypes.object,
  part: PropTypes.string,
  showIndex: PropTypes.array,
  showColumns: PropTypes.array,
  col: PropTypes.any,
  showIcon: PropTypes.bool
}

InspectItemCom.defaultProps = {
  report: {},
  part: '',
  showIndex: [],
  showColumns: [],
  col: null,
  showIcon: false
}
